/** @format */

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../../extra/Input";
import SettingBox from "./SettingBox";
import { connect, useDispatch, useSelector } from "react-redux";
import { getSetting, updateSetting, handleToggleSwitch } from "../../store/setting/setting.action";
import Button from "../../extra/Button";

const LogisticsSetting = (props) => {
	const { setting } = useSelector((state) => state.setting);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const [kosPublicKey, setKosPublicKey] = useState("");
	const [kosSecretKey, setKosSecretKey] = useState("");
	const [kosIsProduction, setKosIsProduction] = useState(false);
	const [kosIsEnabled, setKosIsEnabled] = useState(false);
	const [sellerShipsEnabled, setSellerShipsEnabled] = useState(false);
	const [paidShippingEnabled, setPaidShippingEnabled] = useState(false);

	const [error, setError] = useState({
		kosPublicKey: "",
		kosSecretKey: "",
	});

	useEffect(() => {
		dispatch(getSetting());
	}, [dispatch]);

	useEffect(() => {
		setKosPublicKey(setting?.kosLogistics?.publicKey || "");
		setKosSecretKey(setting?.kosLogistics?.secretKey || "");
		setKosIsProduction(setting?.kosLogistics?.isProduction || false);
		setKosIsEnabled(setting?.kosLogistics?.isEnabled || false);
		setSellerShipsEnabled(setting?.sellerShips?.isEnabled || false);
		setPaidShippingEnabled(setting?.paidShipping?.isEnabled || false);
	}, [setting]);

	const handleSubmit = () => {
		if (!kosPublicKey || !kosSecretKey) {
			let error = {};
			if (!kosPublicKey) error.kosPublicKey = "KOS Public Key is required";
			if (!kosSecretKey) error.kosSecretKey = "KOS Secret Key is required";
			return setError({ ...error });
		}

		let settingData = {
			kosLogistics: {
				publicKey: kosPublicKey,
				secretKey: kosSecretKey,
				isProduction: kosIsProduction,
			},
		};

		props.updateSetting(settingData, setting?._id);
	};

	const handleClick = (type) => {
		props.handleToggleSwitch(setting?._id, type);
	};

	return (
		<>
			<div className='mainSettingBar' style={{ margin: "0px" }}>
				<div className='settingBar'>
					<div className='settingHeader primeHeader'>
						<div className='col-12 headname' style={{ marginTop: "15px", marginBottom: "-5px" }}>
							Logistics Setting
						</div>
					</div>
					<div className='settingMain'>
						<div className='row'>
							<SettingBox
								submit={(e) => handleSubmit(e)}
								title={`KOS (Kxpress) Logistics`}
								toggleSwitch={{
									switchName: "Enabled",
									switchValue: kosIsEnabled,
									handleClick: () => {
										handleClick("kosLogistics");
									},
								}}>
								<Input
									type={`text`}
									label={`Public Key`}
									value={kosPublicKey}
									newClass={`col-12`}
									placeholder={`Enter your KOS Public Key....`}
									errorMessage={error.kosPublicKey && error.kosPublicKey}
									onChange={(e) => {
										setKosPublicKey(e.target.value);
										if (!e.target.value) {
											return setError({
												...error,
												kosPublicKey: "KOS Public Key Is Required",
											});
										} else {
											return setError({
												...error,
												kosPublicKey: "",
											});
										}
									}}
								/>

								<Input
									type={`text`}
									label={`Secret Key`}
									value={kosSecretKey}
									newClass={`col-12`}
									placeholder={`Enter your KOS Secret Key....`}
									errorMessage={error.kosSecretKey && error.kosSecretKey}
									onChange={(e) => {
										setKosSecretKey(e.target.value);
										if (!e.target.value) {
											return setError({
												...error,
												kosSecretKey: "KOS Secret Key Is Required",
											});
										} else {
											return setError({
												...error,
												kosSecretKey: "",
											});
										}
									}}
								/>

								<div className='col-12 mt-3'>
									<div className='d-flex align-items-center'>
										<input type='checkbox' id='kosProductionMode' checked={kosIsProduction} onChange={(e) => setKosIsProduction(e.target.checked)} style={{ width: "18px", height: "18px", cursor: "pointer" }} />
										<label htmlFor='kosProductionMode' className='ms-2' style={{ cursor: "pointer", fontWeight: 500, fontSize: "14px" }}>
											Production Mode
										</label>
									</div>
									<small style={{ color: "#64748b" }}>When unchecked, staging environment (staging-my.kos.ng) is used. When checked, production (my.kos.ng) is used.</small>
								</div>

								<div className='col-12 mt-3 d-flex justify-content-end'>
									<Button newClass={`whiteFont`} btnName={`Submit`} btnColor={`btnBlackPrime`} style={{ width: "90px", borderRadius: "8px" }} onClick={(e) => handleSubmit(e)} />
								</div>
							</SettingBox>
						</div>

						<div className='row mt-4'>
							<SettingBox
								title={`Seller Ships`}
								toggleSwitch={{
									switchName: "Enabled",
									switchValue: sellerShipsEnabled,
									handleClick: () => {
										handleClick("sellerShips");
									},
								}}>
								<div className='col-12'>
									<p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>When enabled, buyers can choose "Seller Ships" at checkout. The shipping cost will be ₦0 and the buyer agrees to pay the delivery fee on arrival.</p>
								</div>
							</SettingBox>
						</div>

						<div className='row mt-4'>
							<SettingBox
								title={`Paid Shipping`}
								toggleSwitch={{
									switchName: "Enabled",
									switchValue: paidShippingEnabled,
									handleClick: () => {
										handleClick("paidShipping");
									},
								}}>
								<div className='col-12'>
									<p style={{ color: "#64748b", fontSize: "14px", margin: 0 }}>When enabled, buyers pay a flat shipping fee based on their delivery-address state. Lagos is split into Mainland and Island. The fee is charged once per seller in the cart.</p>
								</div>
								<div className='col-12 mt-3 d-flex justify-content-end'>
									<Button newClass={`whiteFont`} btnName={`Manage Rates`} btnColor={`btnBlackPrime`} style={{ borderRadius: "8px", padding: "8px 24px" }} onClick={() => navigate("/admin/paidShippingRates")} />
								</div>
							</SettingBox>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default connect(null, {
	getSetting,
	updateSetting,
	handleToggleSwitch,
})(LogisticsSetting);
